import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "btn-group"
};
import { onMounted, ref, reactive, toRefs, toRaw } from 'vue';
import { ElMessage } from 'element-plus';
import { storeToRefs } from 'pinia';
import { ISSUE_INCIDENT_ENV } from '@/utils/constances';
import { formatInTimeZone } from 'date-fns-tz';
import { mctRequest } from '@/api/axios';
import { useDetailStatusStore } from '@/store/detailStatus';
import { useUserDefaultSettingStore } from '@/store/user';
import { deepClone } from '@/utils/util';
export default /*@__PURE__*/_defineComponent({
  __name: 'Incident',
  props: {
    clusterId: {}
  },
  setup(__props) {
    const store = useUserDefaultSettingStore();
    const {
      userCEC,
      timeZoneArea
    } = storeToRefs(store);
    const detailStatusStore = useDetailStatusStore();
    const {
      selectedFailedDot,
      incidentTicket,
      incIssueNote,
      incidentDialogVisible,
      refreshIncidentTable,
      checkStatus,
      // snowStatus: 1-remedy;2-remedy&snow;3-snow
      snowStatus
    } = storeToRefs(detailStatusStore);
    const props = __props;
    const {
      clusterId
    } = toRefs(props);
    const summary = ref(`Check ${checkStatus.value.hostname} alert in cluster ${checkStatus.value.oneServer.clusterName} at ${checkStatus.value.gmtStatusTime} (UTC)`);
    const note = ref(`==Please visit below URL to see the error detail==\n${window.location.protocol}//${window.location.host}/#ticketDetail.jsp?ag=${selectedFailedDot.value.agentName || 'INTERNAL'}&status=${checkStatus.value.listDetailStatus[0].status}&ticket=${incidentTicket.value}\n\n[zone name:${checkStatus.value.oneServer.zoneName}]${incIssueNote.value.replace(/<br>/g, '\n').replace(/<br\/>/g, '\n').replace(/&lt;/g, '<').replace(/&gt;/g, '>').trim()}`);
    const ruleFormRef = ref();
    const ruleForm = reactive({
      summary: summary.value,
      notes: note.value,
      impactedService: 'SOC Tools',
      urgency: '4-Low',
      impact: '4-Minor/Localized',
      assignmentGroup: '',
      maintainOption: '2',
      env: 'Production',
      autoUnMaintain: '1',
      contactType: 'SOC',
      userName: userCEC.value,
      detailId: incidentTicket.value,
      clusterId: clusterId.value,
      serverId: selectedFailedDot.value.serverId,
      statusId: selectedFailedDot.value.statusId
    });
    const rules = reactive({
      summary: [{
        required: true,
        trigger: 'blur'
      }],
      notes: [{
        required: true,
        trigger: 'blur'
      }],
      assignmentGroup: [{
        required: true,
        trigger: 'change'
      }]
    });
    const businessServiceOptions = ref([]);
    const initBusinessService = async () => {
      const config = {
        url: '/incident/service'
      };
      const {
        IncidentServiceList
      } = await mctRequest.request(config);
      businessServiceOptions.value = IncidentServiceList;
    };
    const supportGroupOptions = ref([]);
    const getSupportGroup = async () => {
      if (supportGroupOptions.value?.length > 0) return;
      const config = {
        url: '/supportgroup',
        isLoading: false
      };
      const {
        SupportGroup
      } = await mctRequest.request(config);
      supportGroupOptions.value = SupportGroup;
    };
    const handleSubmit = async () => {
      if (!ruleFormRef.value) return;
      await ruleFormRef.value.validate(valid => {
        if (valid) {
          openIncident();
        }
      });
    };
    const openIncident = async () => {
      const data = deepClone(toRaw(ruleForm));
      let maintainId = 0;
      if (data.maintainOption === '2') {
        //zone
        maintainId = selectedFailedDot.value.zoneId;
      } else if (data.maintainOption === '3') {
        //check
        maintainId = selectedFailedDot.value.serverId;
      } else if (data.maintainOption === '0') {
        //cluster
        maintainId = clusterId.value;
      }
      if (data.maintainOption !== '-1') {
        data.maintainItems = {
          user: userCEC.value,
          reason: '',
          duration: '999999',
          endTime: '',
          startTime: formatInTimeZone(new Date(), timeZoneArea.value, 'yyyy-MM-dd HH:mm:ss'),
          MaintainItem: [{
            endtime: '',
            reason: '',
            name: checkStatus.value.oneServer.serverIp,
            serverName: checkStatus.value.oneServer.serverIp,
            clusterName: checkStatus.value.oneServer.clusterName,
            maintainType: data.maintainOption,
            id: maintainId?.toString()
          }]
        };
        data.maintainResults = [{
          clusterName: checkStatus.value.oneServer.clusterName,
          name: checkStatus.value.oneServer.serverIp,
          maintainLevel: data.maintainOption,
          id: maintainId?.toString()
        }];
      }
      delete data.maintainOption;
      const config = {
        url: '/incident',
        method: 'post',
        data
      };
      // console.log('@@@', config)
      await mctRequest.request(config);
      ElMessage({
        message: 'Successfully opened an incident!',
        type: 'success'
      });
      incidentDialogVisible.value = false;
      refreshIncidentTable.value++;
    };
    const fillForm = () => {
      if (snowStatus.value === '1') {
        ruleForm.urgency = '4-Low';
        ruleForm.impact = '4-Minor/Localized';
      } else {
        ruleForm.urgency = '4';
        ruleForm.impact = '4';
      }
    };
    onMounted(() => {
      initBusinessService();
      fillForm();
      getSupportGroup();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm,
        rules: rules,
        "label-width": "160px",
        class: "incident-form",
        "status-icon": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "Summary",
          prop: "summary"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            class: "input-box",
            modelValue: ruleForm.summary,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ruleForm.summary = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Notes",
          prop: "notes"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            class: "input-box",
            rows: 10,
            modelValue: ruleForm.notes,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ruleForm.notes = $event),
            type: "textarea"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Business Service",
          prop: "impactedService"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            class: "input-box",
            filterable: "",
            modelValue: ruleForm.impactedService,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ruleForm.impactedService = $event)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessServiceOptions.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: item,
                value: item,
                key: item
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Urgency",
          prop: "urgency"
        }, {
          default: _withCtx(() => [_unref(snowStatus) === '1' ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            class: "input-box",
            modelValue: ruleForm.urgency,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ruleForm.urgency = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "1-Critical",
              value: "1-Critical"
            }), _createVNode(_component_el_option, {
              label: "2-High",
              value: "2-High"
            }), _createVNode(_component_el_option, {
              label: "3-Medium",
              value: "3-Medium"
            }), _createVNode(_component_el_option, {
              label: "4-Low",
              value: "4-Low"
            })]),
            _: 1
          }, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            class: "input-box",
            modelValue: ruleForm.urgency,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ruleForm.urgency = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "1-Critical",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "2-High",
              value: "2"
            }), _createVNode(_component_el_option, {
              label: "3-Medium",
              value: "3"
            }), _createVNode(_component_el_option, {
              label: "4-Low",
              value: "4"
            })]),
            _: 1
          }, 8, ["modelValue"]))]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Impact",
          prop: "impact"
        }, {
          default: _withCtx(() => [_unref(snowStatus) === '1' ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            class: "input-box",
            modelValue: ruleForm.impact,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ruleForm.impact = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "1-Extensive/Widespread",
              value: "1-Extensive/Widespread"
            }), _createVNode(_component_el_option, {
              label: "2-Significant/Large",
              value: "2-Significant/Large"
            }), _createVNode(_component_el_option, {
              label: "3-Moderate/Limited",
              value: "3-Moderate/Limited"
            }), _createVNode(_component_el_option, {
              label: "4-Minor/Localized",
              value: "4-Minor/Localized"
            })]),
            _: 1
          }, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            class: "input-box",
            modelValue: ruleForm.impact,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ruleForm.impact = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "1-Critical",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "2-High",
              value: "2"
            }), _createVNode(_component_el_option, {
              label: "3-Medium",
              value: "3"
            }), _createVNode(_component_el_option, {
              label: "4-Low",
              value: "4"
            })]),
            _: 1
          }, 8, ["modelValue"]))]),
          _: 1
        }), _unref(snowStatus) !== '1' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "Assignment Group",
          prop: "assignmentGroup"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            class: "input-box",
            filterable: "",
            modelValue: ruleForm.assignmentGroup,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ruleForm.assignmentGroup = $event)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supportGroupOptions.value, (item, index) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: index,
                label: item.supportGroup,
                value: item.supportGroup
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "Maintain",
          prop: "maintainOption"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            class: "input-box",
            modelValue: ruleForm.maintainOption,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ruleForm.maintainOption = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: 'Current Check, ' + _unref(checkStatus).oneServer.serverIp,
              value: "3"
            }, null, 8, ["label"]), _createVNode(_component_el_option, {
              label: 'Current Zone, ' + _unref(checkStatus).oneServer.zoneName,
              value: "2"
            }, null, 8, ["label"]), _createVNode(_component_el_option, {
              label: 'Current Cluster, ' + _unref(checkStatus).oneServer.clusterName,
              value: "0"
            }, null, 8, ["label"]), _createVNode(_component_el_option, {
              label: "No Select",
              value: "-1"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "Environment",
          prop: "env"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            class: "input-box",
            modelValue: ruleForm.env,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ruleForm.env = $event)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ISSUE_INCIDENT_ENV), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.label,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
        class: "return-btn",
        onClick: _cache[10] || (_cache[10] = $event => incidentDialogVisible.value = false)
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode(" Return ")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("Submit")])),
        _: 1
      })])], 64);
    };
  }
});